angular.module('bmsApp.audit').controller('AuditLogCtrl', function ($state,
																	$scope,
																	$q,
																	ngTableParams,
																	EnquirySvc,
																	AuditLogSvc) {

	function defaultAuditParams() {
		return {
			page: 1, // show first page
			count: $scope.config.table.params.count, // count per page
			sorting: {
				created_at: 'desc'     // initial sorting
			},
			filter: {
				event_name: null
			}
		};
	}

	function init() {
		initTable();
		$q.all([
			initFilters()
		]).then(function () {
			self.loading = false;
		});
	}

	function initTable() {
		var params = defaultAuditParams();
		self.table = new ngTableParams(params, {
			total: 0, // length of data
			counts: $scope.config.table.settings.counts, // available page counts
			getData: function ($defer, params) {
				self.updating = true;
				AuditLogSvc.getAuditLog(params.$params)
					.then(function (response) {
						angular.forEach(response.data.audit_event_collection, function (value) {
							if (angular.isObject(value.auditable)) {
								var auditable = value.auditable;
								switch (auditable.class) {
									case 'Employee':
										auditable.href = $scope.isBms2Module('Employees') ? $state.href('main.employee.index.view', {employeeId: auditable.id}) : ($scope.href + '/brand/employee/employees/view/id/' + auditable.id);
										break;
									case 'Prospect':
										auditable.href = $scope.isBms2Module('CRM') ? $state.href('main.crm.prospect.index.view', {prospectId: auditable.id}) : '/brand/crm/opportunities/view/id/' + auditable.id;
										break;
									case 'Enquiry':
										auditable.href = $scope.isBms2Module('CRM') ? $state.href('main.crm.enquiry.index.view', {enquiryId: auditable.id}) : '/brand/crm/enquiries/view/id/' + auditable.id;
										break;
									case 'Customer':
										auditable.href = $scope.isBms2Module('CRM') ? $state.href('main.crm.customer.index.view', {customerId: auditable.id}) : ($scope.href + '/brand/crm/customers/view/id/' + auditable.id);
										break;
									case 'CustomerPayment':
										auditable.href = $scope.isBms2Module('CRM') ? $state.href('main.crm.customer.index.view', {customerId: auditable.customer_id}) : ($scope.href + '/brand/crm/customers/view/id/' + auditable.customer_id);
										break;
									case 'CustomerGroup':
										auditable.href = $scope.isBms2Module('Marketing') ? $state.href('main.marketing.customerGroupIndex.customerGroupEdit', {id: auditable.id}) : '/brand/marketing/advertising_groups/view/id/' + auditable.id;
										break;
									case 'Campaign':
										auditable.href = $scope.isBms2Module('Marketing') ? $state.href('main.marketing.campaignIndex.campaignUpdate', {id: auditable.id}) : '/brand/marketing/campaigns/view/id/' + auditable.id;
										break;
									case 'Initiative':
										auditable.href = $scope.isBms2Module('Marketing') ? $state.href('main.marketing.campaignIndex.campaignOverview.initiativeUpdate', {id: auditable.id}) : '/brand/marketing/initiatives/edit/id/' + auditable.id + '/campaign-id/' + auditable.campaign_id;
										break;
									case 'mmJob':
										auditable.href = '/brand/merrymaids/jobs/view/id/' + auditable.id;
										break;
									case 'mmJobPart':
										auditable.href = '/brand/merrymaids/jobs/closejob/id/' + auditable.id;
										break;
									case 'tgJob':
										auditable.href = '/brand/trugreen/quotes/view/quote-id/' + auditable.id;
										break;
									case 'tgVisit':
										auditable.href = '/brand/trugreen/jobs/close_visit/id/' + auditable.id;
										break;
									case 'tgVisitTreatment':
										auditable.href = '/brand/trugreen/jobs/close_visit/id/' + auditable.visit_id;
										break;
									default:
										auditable.href = null;
										break;
								}
								//console.info(auditable.href);
							}
						});
						params.total(response.data.audit_event_filtered_count);
						$defer.resolve(response.data.audit_event_collection);
					})
					.finally(function () {
						self.updating = false;
					});
			}
		});
	}

	function initFilters() {
		return AuditLogSvc.getEventNameOptions().then(function (response) {
			self.options.name = response.data.event_name_options;
		});
	}

	function filterApply() {
		console.info('Applying filter');
		console.info(angular.copy(self.table.$params));
		console.info(angular.copy(self.tempFilters));
		angular.extend(self.table.$params.filter, angular.copy(self.tempFilters));
		console.info(angular.copy(self.table.$params));
	}

	function filterReset() {
		console.info('Resetting filter');
		angular.extend(self.tempFilters, defaultAuditParams().filter);
		angular.extend(self.table.$params, defaultAuditParams());
	}

	function toggleEventData(auditEvent) {
		auditEvent.data_visible = !auditEvent.data_visible;
	}

	var self = {
		loading: true,
		updating: false,
		methods: {
			init: init,
			filterApply: filterApply,
			filterReset: filterReset,
			toggleEventData: toggleEventData
		},
		options: {},
		tempFilters: {}
	};


	$scope.AuditLogCtrl = self;

});
